module.exports = __webpack_public_path__ + "img/lantern.1f6a7765.png";